export default "__VITE_ASSET__DjVlqKoS__"